import { SprayOrSprayZoneChartConfigDto, SprayOrSprayZoneChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';

import SprayChart from 'components/SprayChart/SprayChart';
import SprayZoneChart from 'components/SprayZoneChart/SprayZoneChart';

const PlayerSprayOrSprayZoneChart = ({
  chartData,
  isLoading,
  extraChartData,
}: ChartProps<SprayOrSprayZoneChartDataDto, SprayOrSprayZoneChartConfigDto>) => {
  return extraChartData.viewChartAs === 'SprayChart' ? (
    <SprayChart sprays={chartData?.sprays ?? []} isLoading={isLoading} />
  ) : (
    <SprayZoneChart sprayZones={chartData?.sprayZones ?? []} isLoading={isLoading} />
  );
};

export default PlayerSprayOrSprayZoneChart;
